import React, { useState, useEffect } from "react";
import axios from "axios";
import { FiRefreshCw, FiSearch, FiTrendingUp, FiCalendar, FiDollarSign, FiFilter } from "react-icons/fi";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap');

  .puap-root {
    font-family: 'Montserrat', sans-serif;
    min-height: 100vh;
    background: linear-gradient(135deg, #f1f5f9 0%, #eff6ff 50%, #f1f5f9 100%);
    padding: 16px;
  }

  @media (min-width: 640px) {
    .puap-root {
      padding: 24px;
    }
  }

  .puap-container {
    max-width: 80rem;
    margin: 0 auto;
  }

  /* Header Section */
  .puap-header {
    background: #ffffff;
    border-radius: 16px;
    padding: 24px 32px;
    margin-bottom: 24px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .puap-header-top {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
  }

  @media (min-width: 640px) {
    .puap-header-top {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
  }

  .puap-title {
    font-size: 28px;
    font-weight: 800;
    background: linear-gradient(135deg, #1e293b, #475569);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 8px;
  }

  @media (min-width: 640px) {
    .puap-title {
      font-size: 36px;
    }
  }

  .puap-description {
    color: #64748b;
    font-size: 14px;
  }

  @media (min-width: 640px) {
    .puap-description {
      font-size: 16px;
    }
  }

  .puap-refresh-btn {
    padding: 12px 24px;
    background: linear-gradient(135deg, #14b8a6, #0d9488);
    color: #ffffff;
    border: none;
    border-radius: 12px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
  }

  .puap-refresh-btn:hover {
    background: linear-gradient(135deg, #0d9488, #0f766e);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.2);
    transform: translateY(-2px);
  }

  /* Total Income Card */
  .puap-total-card {
    border-radius: 16px;
    padding: 24px 32px;
    color: #ffffff;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  }

  .puap-total-card-blue {
    background: linear-gradient(135deg, #3b82f6, #2563eb);
  }

  .puap-total-card-emerald {
    background: linear-gradient(135deg, #10b981, #059669);
  }

  .puap-total-card-purple {
    background: linear-gradient(135deg, #8b5cf6, #7c3aed);
  }

  .puap-total-card-orange {
    background: linear-gradient(135deg, #f59e0b, #d97706);
  }

  .puap-total-card-pink {
    background: linear-gradient(135deg, #ec4899, #db2777);
  }

  .puap-total-card-cyan {
    background: linear-gradient(135deg, #06b6d4, #0891b2);
  }

  .puap-total-card-amber {
    background: linear-gradient(135deg, #fbbf24, #f59e0b);
  }

  .puap-total-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
  }

  .puap-total-header svg {
    opacity: 0.8;
  }

  .puap-total-label {
    font-size: 14px;
    font-weight: 500;
    opacity: 0.9;
  }

  @media (min-width: 640px) {
    .puap-total-label {
      font-size: 16px;
    }
  }

  .puap-total-amount {
    font-size: 36px;
    font-weight: 700;
    margin-bottom: 16px;
  }

  @media (min-width: 640px) {
    .puap-total-amount {
      font-size: 48px;
    }
  }

  .puap-total-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    font-size: 14px;
    opacity: 0.9;
  }

  .puap-total-stats-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  /* Statistics Cards */
  .puap-stats-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    margin-bottom: 24px;
  }

  @media (min-width: 640px) {
    .puap-stats-grid {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (min-width: 1024px) {
    .puap-stats-grid {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  .puap-stat-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  }

  .puap-stat-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
  }

  .puap-stat-icon-wrap {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .puap-stat-icon-wrap-blue {
    background: #dbeafe;
  }

  .puap-stat-icon-wrap-blue svg {
    color: #2563eb;
  }

  .puap-stat-icon-wrap-emerald {
    background: #d1fae5;
  }

  .puap-stat-icon-wrap-emerald svg {
    color: #059669;
  }

  .puap-stat-icon-wrap-purple {
    background: #ede9fe;
  }

  .puap-stat-icon-wrap-purple svg {
    color: #7c3aed;
  }

  .puap-stat-icon-wrap-orange {
    background: #fef3c7;
  }

  .puap-stat-icon-wrap-orange svg {
    color: #d97706;
  }

  .puap-stat-label {
    font-size: 14px;
    font-weight: 500;
    color: #64748b;
  }

  .puap-stat-value {
    font-size: 24px;
    font-weight: 700;
    color: #1e293b;
  }

  /* Search and Filter */
  .puap-search-bar {
    background: #ffffff;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  }

  @media (min-width: 640px) {
    .puap-search-bar {
      flex-direction: row;
      align-items: center;
    }
  }

  .puap-search-wrap {
    position: relative;
    flex: 1;
  }

  .puap-search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
  }

  .puap-search-input {
    width: 100%;
    padding: 12px 16px 12px 40px;
    border: 1px solid #cbd5e1;
    border-radius: 12px;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;
    outline: none;
    transition: all 0.2s;
  }

  .puap-search-input:focus {
    border-color: #14b8a6;
    box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.2);
  }

  .puap-filter-info {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #64748b;
    font-size: 14px;
    white-space: nowrap;
  }

  /* Transactions Table */
  .puap-table-wrap {
    background: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e2e8f0;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  }

  .puap-loading {
    padding: 48px;
    text-align: center;
  }

  .puap-spinner {
    display: inline-block;
    width: 48px;
    height: 48px;
    border: 4px solid #14b8a6;
    border-top-color: transparent;
    border-radius: 50%;
    animation: puap-spin 0.8s linear infinite;
    margin-bottom: 16px;
  }

  @keyframes puap-spin {
    to { transform: rotate(360deg); }
  }

  .puap-loading-text {
    color: #64748b;
  }

  .puap-empty {
    padding: 48px;
    text-align: center;
  }

  .puap-empty-icon {
    width: 64px;
    height: 64px;
    margin: 0 auto 16px;
    border-radius: 50%;
    background: #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .puap-empty-icon svg {
    color: #94a3b8;
  }

  .puap-empty-title {
    font-size: 18px;
    font-weight: 600;
    color: #334155;
    margin-bottom: 8px;
  }

  .puap-empty-text {
    color: #64748b;
    font-size: 14px;
  }

  .puap-table-scroll {
    overflow-x: auto;
  }

  .puap-table {
    width: 100%;
    border-collapse: collapse;
  }

  .puap-table-head {
    background: linear-gradient(135deg, #f8fafc, #f1f5f9);
    border-bottom: 1px solid #e2e8f0;
  }

  .puap-table-head th {
    padding: 16px 24px;
    text-align: left;
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  @media (min-width: 640px) {
    .puap-table-head th {
      font-size: 14px;
    }
  }

  .puap-table-head th.right {
    text-align: right;
  }

  .puap-table-body {
    border-top: 1px solid #e2e8f0;
  }

  .puap-table-body tr {
    transition: all 0.2s ease;
    border-bottom: 1px solid #f1f5f9;
  }

  .puap-table-body tr:hover {
    background: linear-gradient(135deg, #f8fafc, #eff6ff);
  }

  .puap-table-body tr:first-child {
    background: rgba(59, 130, 246, 0.05);
  }

  .puap-table-body td {
    padding: 16px 24px;
  }

  .puap-date {
    font-size: 14px;
    font-weight: 500;
    color: #1e293b;
  }

  .puap-time {
    font-size: 12px;
    color: #94a3b8;
  }

  .puap-badge {
    padding: 6px 12px;
    border-radius: 9999px;
    font-size: 12px;
    font-weight: 600;
    display: inline-block;
  }

  .puap-badge-blue {
    background: #dbeafe;
    color: #1e40af;
  }

  .puap-badge-emerald {
    background: #d1fae5;
    color: #065f46;
  }

  .puap-badge-purple {
    background: #ede9fe;
    color: #5b21b6;
  }

  .puap-badge-orange {
    background: #fef3c7;
    color: #92400e;
  }

  .puap-badge-pink {
    background: #fce7f3;
    color: #9d174d;
  }

  .puap-badge-cyan {
    background: #cffafe;
    color: #0e7490;
  }

  .puap-badge-amber {
    background: #fef3c7;
    color: #92400e;
  }

  .puap-amount {
    font-weight: 700;
    font-size: 18px;
    color: #059669;
    text-align: right;
  }

  .puap-description-cell {
    font-size: 14px;
    color: #475569;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* Footer */
  .puap-footer {
    margin-top: 24px;
    text-align: center;
    font-size: 14px;
    color: #94a3b8;
  }

  /* Responsive */
  @media (max-width: 640px) {
    .puap-header {
      padding: 16px;
    }

    .puap-total-card {
      padding: 16px 20px;
    }

    .puap-total-amount {
      font-size: 28px;
    }

    .puap-table-body td {
      padding: 12px 16px;
    }

    .puap-table-head th {
      padding: 12px 16px;
    }

    .puap-description-cell {
      max-width: 120px;
    }
  }
`;

const PUAPIncomePage = ({ user, incomeType, title, description }) => {
  const [transactions, setTransactions] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const endpointMap = {
    "direct-income": "/dashboard/puap/direct-income",
    "matrix-income": "/dashboard/puap/matrix-income",
    "generation-income": "/dashboard/puap/generation-income",
    "active-member-income": "/dashboard/puap/active-member-income",
    "reward-tour-income": "/dashboard/puap/reward-tour-income",
    "car-bonus-income": "/dashboard/puap/car-bonus-income",
    "royalty-income": "/dashboard/puap/royalty-income",
  };

  const typeLabels = {
    "direct-income": "Direct Bonus",
    "matrix-income": "Matrix Income",
    "generation-income": "Generation Income",
    "active-member-income": "Active Member Reward",
    "reward-tour-income": "Reward Tour Bonus",
    "car-bonus-income": "Car Bonus",
    "royalty-income": "Royalty Bonus",
  };

  const gradientColors = {
    "direct-income": "puap-total-card-blue",
    "matrix-income": "puap-total-card-emerald",
    "generation-income": "puap-total-card-purple",
    "active-member-income": "puap-total-card-orange",
    "reward-tour-income": "puap-total-card-pink",
    "car-bonus-income": "puap-total-card-cyan",
    "royalty-income": "puap-total-card-amber",
  };

  const badgeColors = {
    "direct-income": "puap-badge-blue",
    "matrix-income": "puap-badge-emerald",
    "generation-income": "puap-badge-purple",
    "active-member-income": "puap-badge-orange",
    "reward-tour-income": "puap-badge-pink",
    "car-bonus-income": "puap-badge-cyan",
    "royalty-income": "puap-badge-amber",
  };

  const statIconColors = {
    "direct-income": "puap-stat-icon-wrap-blue",
    "matrix-income": "puap-stat-icon-wrap-emerald",
    "generation-income": "puap-stat-icon-wrap-purple",
    "active-member-income": "puap-stat-icon-wrap-orange",
    "reward-tour-income": "puap-stat-icon-wrap-pink",
    "car-bonus-income": "puap-stat-icon-wrap-cyan",
    "royalty-income": "puap-stat-icon-wrap-amber",
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const endpoint = endpointMap[incomeType];
      if (!endpoint) {
        console.error("Invalid income type:", incomeType);
        setLoading(false);
        return;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}${endpoint}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setTransactions(data.transactions || []);
      setTotal(data.total || 0);
    } catch (error) {
      console.error("Error fetching income data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [incomeType]);

  const filteredTransactions = transactions.filter((tx) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      tx.description?.toLowerCase().includes(searchLower) ||
      tx.amount?.toString().includes(searchLower)
    );
  });

  const transactionCount = filteredTransactions.length;
  const averageAmount = transactionCount > 0 ? total / transactionCount : 0;
  const highestTransaction = transactionCount > 0 ? Math.max(...filteredTransactions.map(t => t.amount)) : 0;
  const lowestTransaction = transactionCount > 0 ? Math.min(...filteredTransactions.map(t => t.amount)) : 0;

  const dateRange = transactionCount > 0 ? {
    start: new Date(filteredTransactions[filteredTransactions.length - 1]?.createdAt),
    end: new Date(filteredTransactions[0]?.createdAt)
  } : null;

  return (
    <div className="puap-root">
      <style>{styles}</style>
      <div className="puap-container">
        {/* Header Section */}
        <div className="puap-header">
          <div className="puap-header-top">
            <div>
              <h1 className="puap-title">{title}</h1>
              <p className="puap-description">{description}</p>
            </div>
            <button
              onClick={fetchData}
              className="puap-refresh-btn"
            >
              <FiRefreshCw size={18} />
              Refresh
            </button>
          </div>

          {/* Total Income Card */}
          <div className={`puap-total-card ${gradientColors[incomeType]}`}>
            <div className="puap-total-header">
              <FiDollarSign size={24} />
              <p className="puap-total-label">Total {typeLabels[incomeType]}</p>
            </div>
            <p className="puap-total-amount">₹{total.toLocaleString("en-IN")}</p>
            <div className="puap-total-stats">
              <div className="puap-total-stats-item">
                <FiTrendingUp size={16} />
                <span>{transactionCount} transactions</span>
              </div>
              {dateRange && (
                <div className="puap-total-stats-item">
                  <FiCalendar size={16} />
                  <span>
                    {dateRange.start.toLocaleDateString("en-IN", { month: "short", year: "numeric" })} - {dateRange.end.toLocaleDateString("en-IN", { month: "short", year: "numeric" })}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Statistics Cards */}
        <div className="puap-stats-grid">
          <div className="puap-stat-card">
            <div className="puap-stat-header">
              <div className={`puap-stat-icon-wrap ${statIconColors[incomeType]}`}>
                <FiTrendingUp size={20} />
              </div>
              <p className="puap-stat-label">Total Transactions</p>
            </div>
            <p className="puap-stat-value">{transactionCount}</p>
          </div>

          <div className="puap-stat-card">
            <div className="puap-stat-header">
              <div className={`puap-stat-icon-wrap ${statIconColors[incomeType]}`}>
                <FiDollarSign size={20} />
              </div>
              <p className="puap-stat-label">Average Amount</p>
            </div>
            <p className="puap-stat-value">₹{averageAmount.toLocaleString("en-IN", { maximumFractionDigits: 0 })}</p>
          </div>

          <div className="puap-stat-card">
            <div className="puap-stat-header">
              <div className={`puap-stat-icon-wrap ${statIconColors[incomeType]}`}>
                <FiTrendingUp size={20} />
              </div>
              <p className="puap-stat-label">Highest Transaction</p>
            </div>
            <p className="puap-stat-value">₹{highestTransaction.toLocaleString("en-IN")}</p>
          </div>

          <div className="puap-stat-card">
            <div className="puap-stat-header">
              <div className={`puap-stat-icon-wrap ${statIconColors[incomeType]}`}>
                <FiDollarSign size={20} />
              </div>
              <p className="puap-stat-label">Lowest Transaction</p>
            </div>
            <p className="puap-stat-value">₹{lowestTransaction.toLocaleString("en-IN")}</p>
          </div>
        </div>

        {/* Search and Filter */}
        <div className="puap-search-bar">
          <div className="puap-search-wrap">
            <FiSearch className="puap-search-icon" />
            <input
              type="text"
              placeholder="Search by description or amount..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="puap-search-input"
            />
          </div>
          <div className="puap-filter-info">
            <FiFilter size={18} />
            <span>{filteredTransactions.length} of {transactions.length} transactions</span>
          </div>
        </div>

        {/* Transactions Table */}
        <div className="puap-table-wrap">
          {loading ? (
            <div className="puap-loading">
              <div className="puap-spinner"></div>
              <p className="puap-loading-text">Loading transactions...</p>
            </div>
          ) : filteredTransactions.length === 0 ? (
            <div className="puap-empty">
              <div className="puap-empty-icon">
                <FiDollarSign size={32} />
              </div>
              <h3 className="puap-empty-title">
                {searchTerm ? "No transactions match your search" : "No transactions found"}
              </h3>
              <p className="puap-empty-text">
                {searchTerm ? "Try a different search term" : "Start earning to see your transactions here"}
              </p>
            </div>
          ) : (
            <div className="puap-table-scroll">
              <table className="puap-table">
                <thead className="puap-table-head">
                  <tr>
                    <th>Date & Time</th>
                    <th>Type</th>
                    <th className="right">Amount</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody className="puap-table-body">
                  {filteredTransactions.map((tx, index) => (
                    <tr key={tx._id}>
                      <td>
                        <div className="puap-date">
                          {new Date(tx.createdAt).toLocaleDateString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })}
                        </div>
                        <div className="puap-time">
                          {new Date(tx.createdAt).toLocaleTimeString("en-IN", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </div>
                      </td>
                      <td>
                        <span className={`puap-badge ${badgeColors[incomeType]}`}>
                          {typeLabels[incomeType]}
                        </span>
                      </td>
                      <td>
                        <div className="puap-amount">
                          +₹{Number(tx.amount || 0).toLocaleString("en-IN")}
                        </div>
                      </td>
                      <td>
                        <p className="puap-description-cell" title={tx.description}>
                          {tx.description || "—"}
                        </p>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Footer Info */}
        <div className="puap-footer">
          <p>Showing {filteredTransactions.length} of {transactions.length} transactions</p>
        </div>
      </div>
    </div>
  );
};

export default PUAPIncomePage;